// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"CroppedImage_imageWrapper__1WXWS","image":"CroppedImage_image__1u1Hu"};